import HeroBanner from "../components/HeroBanner";
import HeroList from "../components/HeroList";
import HomeLearning from "../components/HomeLearning";
import HomeWhyUs from "../components/HomeWhyUs";
import StoryTime from "../components/StoryTime";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { URLS } from "../utils/constants";

/**
 * Halaman utama Childreams Studio yang menampilkan berbagai produk dan cerita
 * menarik yang kami ciptakan untuk anak-anak. Halaman ini juga menampilkan
 * informasi tentang komitmen kami terhadap pesan positif dan edukatif yang
 * kami sampaikan melalui cerita-cerita yang kami ciptakan.
 *
 * @returns {JSX.Element} Halaman utama Childreams Studio
 */
const Home = () => {
  const meta = URLS.home;

  return (
    <div className="home-page">
      <Seo title={meta.title} description={meta.desc} keywords={meta.keywords} image={meta.metaImage} path={meta.path} />
      <h1 className="visually-hidden">{meta.title}</h1>
      {/* Hero Section */}
      <HeroBanner />

      {/* Story Time Section */}
      <StoryTime />

      {/* Learning Characters Section */}
      <HeroList />

      {/* Learning Section */}
      <HomeLearning />

      {/* Quality and Innovation Section */}
      <HomeWhyUs />

      <Footer />
    </div>
  );
};

export default Home;
